import { createSelector, RootStateSelectors } from 'reselect';

const selectSaleInvoice = (state: RootStateSelectors): any => state.SaleInvoice;
export const SaleInvoiceProperties = createSelector([selectSaleInvoice], (saleInvoice) => {
  const activeTab = saleInvoice.tabs.find((tab: any) => tab.id === saleInvoice.activeTabId) ?? null;

  return {
    tabs: saleInvoice.tabs,
    activeTabId: saleInvoice.activeTabId,
    activeTab,
    activeTabMedicines: activeTab?.selectedMedicines ?? [],
  };
});
